//-------------------------------------------------------------------------------------------------- Imports
import { useEffect, useState } from "react";
import GoogleMapReact from 'google-map-react';
import { getWifiPoint } from "../../methods/Methods";
import { getGeneralData } from "../../stores/slices/generalDataSlice";
import { useSelector } from "react-redux";
import { ResponseWifiPointsRedesign } from "../../types/common";
import Loading from "../../components/Loading";
import SubDefaultLayout from "../../components/SubDefaultLayout";
import InfoCardComponent from "../../components/InfoCardComponent";
import { images } from "../../routes/ImageRoutes";
import _ from "lodash";

const WifiPoints = () => {
    const generalData = useSelector(getGeneralData);
    const [idCliente, setIdCliente] = useState<string>("");
    const [wifiPointList, setWifiPointList] = useState<Array<ResponseWifiPointsRedesign>>([]);
    const [hasError, setHasError] = useState(false);
    const [message, setMessage] = useState("");
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [currentLat, setCurrentLat] = useState<number>(0);
    const [currentLong, setCurrentLong] = useState<number>(0);

    const renderPolylines = (map: any, maps: any, places: Array<ResponseWifiPointsRedesign>) => {
        let openInfoWindow: { close: () => void; } | null = null;
        places.forEach((place: any) => {
            const marker = new maps.Marker({
                position: {
                    lat: Number(place.latitude),
                    lng: Number(place.longitude),
                },
                map,
                icon: {
                    url: (images.iconMarker),
                },
            });

            const infowindow = new maps.InfoWindow({
                content: `<div>${place.nombreComercial}</div>`,
            });

            marker.addListener('click', () => {
                // cierra el InfoWindow anterior si existe
                if (openInfoWindow) {
                    openInfoWindow.close();
                }

                // Abre el InfoWindow del nuevo marcador
                infowindow.open(map, marker);

                // Actualiza la referencia al InfoWindow actualmente abierto
                openInfoWindow = infowindow;
            });

            new maps.Circle({
                strokeColor: "rgba(101, 170, 213, 0.02)",
                strokeWeight: 1,
                fillColor: "rgba(101, 170, 213, 0.02)",
                map,
                center: {
                    lat: currentLat,
                    lng: currentLong,
                },
                radius: 1000, // Radio en metros
            });
        });
    }

    useEffect(() => {
        if (generalData.selectedContract !== null) {
            setIdCliente(
                generalData.selectedContract.sucursal + generalData.selectedContract.suscriptor
            );
        }
    }, [generalData.selectedContract]);

    useEffect(() => {
        setIsLoading(true);
        if ("geolocation" in navigator && idCliente) {
            navigator.geolocation.getCurrentPosition(async (position) => {
                setIsLoading(true);
                setCurrentLat(position.coords.latitude);
                setCurrentLong(position.coords.longitude);

                await getWifiPoint(idCliente, position.coords.latitude.toString(), position.coords.longitude.toString())
                    .then((response) => {
                        if (response && response.data && response.data.data[0] && !_.isEmpty(response.data.data[0])) {
                            setWifiPointList(response.data.data[0]);
                        } else {
                            setHasError(true);
                            setMessage("No hay Puntos Wifi en su zona.");
                        }
                        setIsLoading(false);
                    })
                    .catch(() => {
                        setHasError(true);
                        setMessage("Hubo un error al procesar su solicitud. \nIntente más tarde.");
                        setIsLoading(false);
                    });
            }, (error) => {
                setHasError(true);
                setIsLoading(false);
                setMessage("No se aceptaron los permisos de ubicación.");
            })
        } else {
            setIsLoading(false);
        }
    }, [idCliente]);

    return (
        <>
            {
                isLoading ?
                    <Loading />
                    :
                    <SubDefaultLayout title={"Puntos Wifi"}>
                        <div style={{ marginTop: 20, height: '100%', width: '100%', marginBottom: 20 }}>
                            {
                                hasError ?
                                    <InfoCardComponent title="¡Estimado usuario!" description={message} />
                                    :
                                    <GoogleMapReact
                                        defaultZoom={15}
                                        bootstrapURLKeys={{ key: "AIzaSyD3FkyYaOav8AvfOUsNzvJUhtH4sLVO5O0" }}
                                        defaultCenter={{ lat: currentLat, lng: currentLong }}
                                        onGoogleApiLoaded={({ map, maps }) => renderPolylines(map, maps, wifiPointList)}
                                    />
                            }
                        </div>
                    </SubDefaultLayout>
            }
        </>
    )
};

//-------------------------------------------------------------------------------------------------- Exports
export default WifiPoints;
